import type { FC } from "react";

import { useCurrentStateAndParams } from "@uirouter/react";
import { ErrorBoundary } from "react-error-boundary";

import { ErrorFallback } from "app/components/error-boundary-no-data/ErrorBoundaryEmptyState";

import { GaConnectMessageListener } from "./GaConnectMessageListener";
import { PremiumFeaturesHomePageContainer } from "./PremiumFeaturesHomePageContainer";

export const PremiumFeaturesHomePageWrapper: FC = () => {
    const { state, params } = useCurrentStateAndParams();

    return (
        <ErrorBoundary
            FallbackComponent={ErrorFallback}
            resetKeys={[state, params]}
        >
            <div className="sw-layout-module-inner">
                <div className="sw-layout-non-scrollable-element use-sticky-css-rendering fadeIn">
                    <GaConnectMessageListener />
                    <PremiumFeaturesHomePageContainer />
                </div>
            </div>
        </ErrorBoundary>
    );
};
